import React from 'react';
import { SmartHeader } from '@/components/SmartHeader';

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SmartHeader />
      <main className="flex-1">{children}</main>
    </div>
  );
}